// eslint-disable-next-line import/no-extraneous-dependencies
import * as amplitude from '@amplitude/analytics-browser';
import isPropValid from '@emotion/is-prop-valid';
import { router } from '@navigation';
import { persistor, store } from '@store';
import { ResetStyle, theme } from '@styles';
import React, { useEffect } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { I18nextProvider } from 'react-i18next';
import { initDB } from 'react-indexed-db-hook';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { StyleSheetManager, ThemeProvider } from 'styled-components';

import { EVENTS } from './constants/amplitudeEvents';
import { DBConfig } from './DBConfig';
import i18n from './i18n';

amplitude.init(process.env.REACT_APP_AMPLITUDE_KEY);
initDB(DBConfig);

const App = () => {
  const handlePersistGateBeforeLift = () => {
    const { language } = store.getState().authSlice;

    i18n.changeLanguage(language);
  };

  useEffect(() => {
    amplitude.track(EVENTS.websiteOpened);
  }, []);

  return (
    <Provider store={store}>
      <PersistGate
        loading={null}
        onBeforeLift={handlePersistGateBeforeLift}
        persistor={persistor}
      >
        <I18nextProvider i18n={i18n}>
          <StyleSheetManager
            enableVendorPrefixes
            shouldForwardProp={(propName, elementToBeRendered) =>
              typeof elementToBeRendered === 'string'
                ? isPropValid(propName)
                : true
            }
          >
            <ThemeProvider theme={theme}>
              <DndProvider backend={HTML5Backend}>
                <ResetStyle />
                <RouterProvider router={router} />
              </DndProvider>
            </ThemeProvider>
          </StyleSheetManager>
        </I18nextProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
